import { INSWITCH_SESSION_KEYS } from '../constants/inswitch.constant';

/**
 * Libera el contexto de una transacción InSwitch almacenado en `sessionStorage`.
 * @returns No retorna valor; elimina la referencia de transacción de `INSWITCH_SESSION_KEYS`.
 */
export function clearInswitchSession(): void {
  sessionStorage.removeItem(INSWITCH_SESSION_KEYS.TRANSACTION_REFERENCE);
}
